<div
  class="sp-shared-info"
  [ngClass]="layout_class">
  <h5 class="sp-color__primary sp-opacity__three-quarters">
    {{ label || '' | translate }}
  </h5>

  <div
    class="sp-row__align"
    style="height: 24px">
    <mat-icon
      (click)="onCopyClick()"
      color="accent"
      style="margin-left: -8px"
      class="sp-icon__s sp-cursor__pointer"
      [matTooltip]="'GENERAL.COPY_CTA' | translate">
      content_copy
    </mat-icon>
    <p [ngClass]="content_class">
      {{ is_shrinked_id ? getShrinkedID() : (content || '-' | translate) }}
    </p>
  </div>

  <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark" />
</div>
